export const media = {
  small: "(max-width: 767px)",
  medium: "(min-width: 768px) and (max-width: 1063px)",
  large: "(min-width: 1064px)",
  extraLarge: "(min-width: 1304px)"
};